// F8 / FR-RD15: feed the desktop meeting recording's mixed audio (system + mic) to the F17
// live session so live transcript and mark-moment apply during the call, as the extension's
// offscreen mixer does for Meet. Best-effort: a failed POST never touches the recording.
import { useEffect, useRef } from "react";
import { ChunkAssembler, tapMono16k } from "../live/audioTap";
import { postAudioChunk } from "../live/client";

export function useLiveAudioTap(sessionId: string | null, stream: MediaStream | null, paused: boolean): void {
  const tapRef = useRef<ReturnType<typeof tapMono16k> | null>(null);

  useEffect(() => {
    if (!sessionId || !stream || stream.getAudioTracks().length === 0) return;
    if (typeof AudioContext === "undefined") return;
    const ctx = new AudioContext();
    const source = ctx.createMediaStreamSource(new MediaStream(stream.getAudioTracks()));
    const assembler = new ChunkAssembler(1);
    let stopped = false;
    const tap = tapMono16k(ctx, source, (frame) => {
      const chunk = assembler.push(frame, ctx.sampleRate);
      if (chunk && !stopped) void postAudioChunk(sessionId, chunk).catch(() => {});
    });
    tapRef.current = tap;
    return () => {
      stopped = true;
      tap.stop();
      tapRef.current = null;
      void ctx.close().catch(() => {});
    };
  }, [sessionId, stream]);

  useEffect(() => {
    if (paused) tapRef.current?.pause();
    else tapRef.current?.resume();
  }, [paused]);
}
